module.exports = __webpack_public_path__ + "img/make-brushes-1_jp.085a063.jpg";